import {
  IInboundSearchFilterOptionDataRaw,
  IInboundSearchFilterOptionFormatted,
  IInboundSearchFilterOptionRaw,
} from '../../../types';

/**
 * Format the response of the inbound search filter options to match the localized custom format
 * to be applied in the filter list screen.
 */
export function formatInboundFilterResponse(
  data: IInboundSearchFilterOptionDataRaw
): IInboundSearchFilterOptionFormatted {
  const formatOptions = (fields: IInboundSearchFilterOptionRaw[]) =>
    fields.map(({ key, value }) => ({
      key,
      label: value,
    }));

  return {
    searchFields: formatOptions(data.searchFields),
    searchKeywords: formatOptions(data.searchKeywords),
  };
}
